<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CForm inline>
              <label
                class="col-form-label ml-2 mr-2"
                style="min-width: 55px; display: block"
                >검색조건</label
              >
              <CSelect
                :value.sync="inFacilityId"
                :options="inFacilityList"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CCardHeader class="p-2 font-weight-bold" style="line-height: 2">
              주기별 생육 지표
            </CCardHeader>
            <CCardBody class="p-2 position-relative">
              <div
                style="
                  width: 5%;
                  height: 80%;
                  position: absolute;
                  top: 30px;
                  left: 5px;
                  background-size: contain;
                  background-repeat: no-repeat;
                  background-position: left center;
                "
                :style="
                  'background-image: url(' +
                  app.publicPath +
                  '/img/growth_y_axis.svg);'
                "
              ></div>
              <div
                ref="chart"
                style="width: 100%; height: 400px; margin: auto 0"
                :class="
                  chart == null || chart.data.length === 0 ? 'd-none' : ''
                "
              ></div>
              <div
                style="
                  width: 100%;
                  height: 400px;
                  display: flex;
                  justify-content: center;
                  flex-direction: column;
                  text-align: center;
                  font-weight: bold;
                  font-size: 150%;
                  color: #ff0d0d;
                "
                v-if="chart == null || chart.data.length === 0"
              >
                <div>
                  <i class="fa fa-times-circle" aria-hidden="true"></i>
                  데이터 없음
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 30px;
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
                "
                :style="
                  'background-image: url(' +
                  app.publicPath +
                  '/img/growth_x_axis.svg);'
                "
              ></div>
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MixinsInFacility from "@/mixins/in-facility";
import core from "@/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import store from "@/store";

export default {
  name: "GrowthIndex",
  components: {},
  mixins: [MixinsInFacility()],
  data() {
    return {
      app: store.state.app,
      chart: null,
    };
  },
  watch: {
    inFacilityId(val) {
      if (val != null) {
        this.getGrowthData();
      }
    },
  },
  methods: {
    async getGrowthData() {
      const str =
        "[{\n" +
        '        "growthAt": "2018-08-22T15:00:00.000Z",\n' +
        '        "diameter": 5.39972223175897,\n' +
        '        "length": null\n' +
        "    }, {\n" +
        '        "growthAt": "2018-08-29T15:00:00.000Z",\n' +
        '        "diameter": 8.57138888041178,\n' +
        '        "length": null\n' +
        "    }, {\n" +
        '        "growthAt": "2018-09-05T15:00:00.000Z",\n' +
        '        "diameter": 12.6069444285499,\n' +
        '        "length": null\n' +
        "    }, {\n" +
        '        "growthAt": "2018-09-12T15:00:00.000Z",\n' +
        '        "diameter": 13.374166727066,\n' +
        '        "length": 13.7083333333333\n' +
        "    }, {\n" +
        '        "growthAt": "2018-09-19T15:00:00.000Z",\n' +
        '        "diameter": 13.8694444762336,\n' +
        '        "length": 16.4583333333333\n' +
        "    }, {\n" +
        '        "growthAt": "2018-09-26T15:00:00.000Z",\n' +
        '        "diameter": 14.3588887850444,\n' +
        '        "length": 20.9444444444444\n' +
        "    }, {\n" +
        '        "growthAt": "2018-10-03T15:00:00.000Z",\n' +
        '        "diameter": 13.8420000893729,\n' +
        '        "length": 18.4857142857143\n' +
        "    }, {\n" +
        '        "growthAt": "2018-10-10T15:00:00.000Z",\n' +
        '        "diameter": 12.8733332422045,\n' +
        '        "length": 18.2222222222222\n' +
        "    }, {\n" +
        '        "growthAt": "2018-10-17T15:00:00.000Z",\n' +
        '        "diameter": 11.1077777014838,\n' +
        '        "length": 15.3611111111111\n' +
        "    }, {\n" +
        '        "growthAt": "2018-10-24T15:00:00.000Z",\n' +
        '        "diameter": 10.4111110634274,\n' +
        '        "length": 19.4166666666667\n' +
        "    }, {\n" +
        '        "growthAt": "2018-10-31T15:00:00.000Z",\n' +
        '        "diameter": 10.7599999109904,\n' +
        '        "length": 19.0833333333333\n' +
        "    }, {\n" +
        '        "growthAt": "2018-11-07T15:00:00.000Z",\n' +
        '        "diameter": 9.29333329200745,\n' +
        '        "length": 18.3333333333333\n' +
        "    }\n" +
        "]\n";
      const data = JSON.parse(str);
      data.forEach((_data, index) => {
        _data.date = core.date.instance(_data.growthAt);
        if (_data.length == null) _data.length = 0;
        _data.label = index + 1 + "주차";
      });
      this.createChart();
      this.chart.data = data;
    },
    createChart() {
      const $el = this.$refs.chart;
      const chart = am4core.create($el, am4charts.XYChart);

      const xAxis = chart.xAxes.push(new am4charts.ValueAxis());
      xAxis.tooltip.disabled = true;
      xAxis.renderer.minGridDistance = 40;
      xAxis.min = -1;
      xAxis.max = 25;
      xAxis.title.text = "화방높이(cm)";

      const xRange = xAxis.axisRanges.create();
      xRange.value = 13.5;
      xRange.endValue = 17;
      xRange.axisFill.stroke = am4core.color("#ffeb3b");
      xRange.axisFill.strokeOpacity = 0.5;
      xRange.axisFill.fill = am4core.color("#ffeb3b");
      xRange.axisFill.fillOpacity = 0.2;

      // Create value axis
      const yAxis = chart.yAxes.push(new am4charts.ValueAxis());
      yAxis.tooltip.disabled = true;
      yAxis.min = -1;
      yAxis.max = 20;
      yAxis.paddingLeft = 10;
      yAxis.title.text = "줄기두께(mm)";

      const yRange = yAxis.axisRanges.create();
      yRange.value = 9;
      yRange.endValue = 12;
      yRange.axisFill.stroke = am4core.color("#795548");
      yRange.axisFill.strokeOpacity = 0.3;
      yRange.axisFill.fill = am4core.color("#795548");
      yRange.axisFill.fillOpacity = 0.2;

      // Create series
      const series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueX = "length";
      series.dataFields.valueY = "diameter";
      series.dataFields.description = "label";
      series.strokeWidth = 1;
      series.stroke = am4core.color("#3F51B5");
      series.fill = am4core.color("#3F51B5");
      series.legendSettings.valueText = "{valueY}";
      series.description;

      series.sequencedInterpolation = true;
      const bullet = series.bullets.push(new am4charts.CircleBullet());
      // bullet.circle.fill = am4core.color("#fff");
      // bullet.circle.stroke = am4core.color("#fff");
      bullet.circle.strokeWidth = 1;

      const labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "[bold]{label}";
      labelBullet.label.verticalCenter = "bottom";
      // labelBullet.label.horizontalCenter = "center";

      labelBullet.label.fontSize = 12;
      labelBullet.label.dx = 0;
      labelBullet.label.dy = -5;

      series.heatRules.push({
        target: bullet.circle,
        min: 5,
        max: 20,
        property: "radius",
      });
      bullet.events.on("hit", function (ev) {
        const data = ev.target.dataItem;
        console.log("data ", data);
        // alert("Clicked on " + ev.target.dataItem.dateX + ": " + ev.target.dataItem.valueY);
      });
      // bullet.tooltipText =
      //   "{description}\n[bold font-size: 20px]{valueY} [font-size: 12px]";
      // // "<b>[[description]] </b><br>화방높이 : <b>[[x]]cm</b> 줄기두께:<b>[[y]] mm</b>"
      bullet.tooltipHTML =
        "<div>" +
        "<div class='text-center'>{description}</div>" +
        "<div>화방높이: <span>{valueX.formatNumber('#.00')}</span>, 줄기두께: <span>{valueY.formatNumber('#.00')}</span></div>" +
        "</div>";
      const scrollbarX = new am4core.Scrollbar();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;
      chart.data = [];
      this.chart = chart;
    },
  },
};
</script>
